module.exports = __webpack_public_path__ + "media/images/logo--white-41d7ef4f212d95b27899a86e00d92241.svg";